import { defineStore } from 'pinia'
import { login, logout, getInfo, getUserInfo, quickLogin } from '@/services/api/login'
import { setToken, removeToken } from '@/services/utils/auth'

const initState = {
    userInfo: {},
    menus: [],
    roles: [],
    agreeProtocol: false,
    smsCountdown: 0 // 验证码倒计时(秒)
}

const useUserStore = defineStore('user', {
    state: () => ({ ...initState }),
    getters: {
        hasLogin: (state) => !!state.userInfo
    },
    actions: {
        login({ username, password }: { username: string; password: string }) {
            const phone = username.trim()
            const pwd = password

            return new Promise<void>((resolve, reject) => {
                login(phone, pwd)
                    .then((res) => {
                        setToken(res.data)
                        resolve()
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        quickLogin(code: string, appid: string) {
            return new Promise<void>((resolve, reject) => {
                quickLogin({ code, appid })
                    .then((res) => {
                        setToken(res.data)
                        resolve()
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        fetchUserInfo() {
            return new Promise((resolve, reject) => {
                getUserInfo()
                    .then((res) => {
                        this.$patch({ userInfo: res.data })
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        fetchPrmissionInfo() {
            return new Promise((resolve, reject) => {
                getInfo()
                    .then((res) => {
                        this.$patch({ menus: res.data.menus })
                        // 赋值权限保留原有数据  去重
                        this.$patch({ roles: res.data.roles })
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        LogOut() {
            return new Promise((resolve, reject) => {
                logout()
                    .then(() => {
                        removeToken()
                        this.resetState()
                        resolve()
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        resetState() {
            this.$patch({ ...initState })
            this.$patch({ userInfo: null })
        },

        setAgreeProtocol(value: boolean) {
            this.$patch({ agreeProtocol: value })
        },

        // 开始验证码倒计时
        startSmsCountdown(seconds: number = 60) {
            this.$patch({ smsCountdown: seconds })

            const timer = setInterval(() => {
                if (this.smsCountdown > 0) {
                    this.$patch({ smsCountdown: this.smsCountdown - 1 })
                } else {
                    clearInterval(timer)
                }
            }, 1000)
        },

        // 重置验证码倒计时
        resetSmsCountdown() {
            this.$patch({ smsCountdown: 0 })
        }
    },
    persist: {
        enabled: true,
        H5Storage: window?.localStorage
    }
})

export { useUserStore }
